var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTagSelector)?_c('div',[(_vm.activeTag)?_c('tag-selector',{attrs:{"active-tag":_vm.activeTag,"is-overview":true}}):(!_vm.activeTag && _vm.hasAnyActiveTag)?_c('v-chip',{staticClass:"invisible-chip"}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }